<template>
  <div class="w-full h-full flex items-center justify-center">
    <div
      class="w-20 h-20 rounded-full border-4 border-primary-lighter border-opacity-30 border-t-white animate-spin"
    ></div>
  </div>
</template>
